import axios, { AxiosRequestConfig } from 'axios';
import { Logger } from '../utils/logger.util';

export const setupAxiosAuthInterceptors = (jweToken: string) => {
  setupRequestInterceptor(jweToken);
  setupErrorResponseInterceptor();
};

const setupRequestInterceptor = (jweToken: string) => {
  const isHybrisRequest = (config: AxiosRequestConfig) => config.url && new RegExp('dcp-api/v2/').test(config.url);
  const isB2xCosRequest = (config: AxiosRequestConfig) => config.url && new RegExp('cos/v1/').test(config.url);

  axios.interceptors.request.use((config) => {
    if (!isHybrisRequest(config) && !isB2xCosRequest(config)) {
      return config;
    }

    if (config.headers) {
      config.headers['Authorization'] = `bearer ${jweToken}`;
    }

    return config;
  });
};

const setupErrorResponseInterceptor = () => {
  const onErrorNotFound = (error: any) => {
    // hack to find the invalid reason in the message property
    const resultInvalidSession = error.message.search('invalid_session');

    if (error.reason === '' && resultInvalidSession > -1) {
      error.reason = 'invalid_session';
    }

    const resultInvalidToken = error.message.search('invalid_token');

    if (error.reason === '' && resultInvalidToken > -1) {
      error.reason = 'invalid_token';
    }

    switch (error.reason) {
      case 'invalid_session':
        Logger.warn('axios::interceptor -> 401 - Not Found - Invalid Session');
        break;
      case 'invalid_token':
        Logger.warn('axios::interceptor -> 401 - Not Found - Invalid Token');
        break;
      default:
        Logger.warn('axios::interceptor -> 401 - Not Found');
        break;
    }
  };

  axios.interceptors.response.use(undefined, (rejection) => {
    if (!rejection.response) {
      // handle preflight options request
      return Promise.reject(rejection);
    }

    const status = parseInt(rejection.response.status, 10);
    const { errors } = rejection.response.data;

    switch (status) {
      case -1:
        break;
      case 304:
        // not modified - delivered from browser cache: handle as FE success.
        return Promise.resolve(rejection.response);
      case 400:
        if (errors?.length) {
          errors.forEach((e: any) => {
            Logger.error(e.toString());
          });
        }

        break;
      case 401:
        errors?.forEach(onErrorNotFound);
        break;
      default:
        if (rejection.statusText) {
          Logger.error(rejection.statusText);
        }
    }

    return Promise.reject(rejection);
  });
};
